<template>
    <div id="app">
        <div class="wrapper mainFlexColumn">
        <slot></slot>
        </div>
        <claim-guide-tab v-if="getReseller.claimGuideTab === 'true'"></claim-guide-tab>
    </div>
</template>
<script>
import claimGuideTab from '@/components/ClaimGuideTab.vue';
import {mapGetters} from 'vuex';
export default {
    components: {
        claimGuideTab
    },
    computed: {
        ...mapGetters({      
            getReseller: 'reseller/getResellerInfo',
        })
    }
}
</script>
